import { DEFAULT_LESSON_PREFERENCES, type LessonPreferences } from "@lib/lessonPreferences";

let activePreferences: LessonPreferences = DEFAULT_LESSON_PREFERENCES;

export function setClientLessonPreferences(preferences: LessonPreferences): void {
  activePreferences = preferences;
}

export function getClientLessonPreferences(): LessonPreferences {
  return activePreferences;
}
